import { render } from "./App.vue?vue&type=template&id=48c34b80&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=48c34b80&lang=css"
import "./App.vue?vue&type=style&index=1&id=48c34b80&scoped=true&lang=css"

import exportComponent from "/Users/tqtifnypmb/Documents/Projects/Freelance/SuperDevUtil/websites/launch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c34b80"]])

export default __exports__